import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [import('./viewer/PageGroup' /* webpackChunkName: "PageGroup" */)],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('PageGroup', UiTypes),
};

export default entry;
